import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getAuthState } from '@sxm-de/dev-kits/web-sdk/utils';
import { IClientSDK } from '@sxm-web/client-sdk-core';

export type PrivacyOptionsOptOutFn = () => void;

export function initPrivacyOptionsOptOutFn({
    dependencies,
}: DomainInitPayload): PrivacyOptionsOptOutFn {
    const { clientSdk } = dependencies;
    return () => {
        window.addEventListener('OneTrustGroupsUpdated', (event) => {
            processOneTrustGroupsUpdated(event as CustomEvent, clientSdk);
        });
    };
}

function processOneTrustGroupsUpdated(
    event: { detail: string[] },
    clientSdk: IClientSDK,
) {
    const doOptOut = !event.detail?.includes('C0004');
    if (doOptOut && getAuthState() === 'authenticated') {
        try {
            clientSdk.user.account().then((account) => {
                if (!account.userOptedOut) {
                    clientSdk.user
                        .recordPrivacyOptionByIdentityId()
                        .then((r) => {});
                }
            });
        } catch (error: any) {
            /**
             * Note:
             * We are silently catching this
             */
        }
    }
}
